import StackImage from "../../../../content/articles/2015-07-03-stack-in-ruby-linked-lists/stack.png";
import LinkedListImage from "../../../../content/articles/2015-07-03-stack-in-ruby-linked-lists/linked-list.png";
import React from 'react';
export default {
  StackImage,
  LinkedListImage,
  React
};